<div class="pr">
  @if (data && showCustomView) {
    <div class="block" style="background-color: #F0F0F0; border: 1px solid #999; padding: 10px 20px;">
      <div class="dblock bold" style="padding-bottom: 10px; border-bottom: 1px solid #999; line-height: 30px;">Customize view<button title="Cancel" (click)="hideCustomView()" style="float: right; background-color: transparent; border: none"><i class="material-icons clear" >clear</i></button></div>
      <div class="dblock">
        <div class="block bold">Data grouping</div>
        <div style="display: flex; flex-direction: row;">
          <div style="padding-right: 10px; border-right: 1px solid #999; margin-right: 10px;">
            <div class="block" style="display: flex; justify-content: space-between;">Positions
              <span style="margin-left: 10px;">
                <mat-slide-toggle [checked]="config.showPositions" (change)="config.showPositions = !config.showPositions; onInputChange()" [disabled]="false"></mat-slide-toggle>
              </span>
            </div>
            @if (data.isAllocationGroupEquivalentsRecordsPresent) {
              <div style="display: flex; justify-content: space-between;">Group equivalents
                <span style="margin-left: 10px;">
                  <mat-slide-toggle [checked]="config.showEquivalents && data.isAllocationGroupEquivalentsRecordsPresent" (change)="config.showEquivalents = !config.showEquivalents; onInputChange()" [disabled]="!data.isAllocationGroupEquivalentsRecordsPresent"></mat-slide-toggle>
                </span>
              </div>
            }
          </div>
          @if (ENABLE_SEC_GRID_CHART) {
            <div style="padding-right: 10px; border-right: 1px solid #999; margin-right: 10px;">
              <div class="block">Schwab Asset Classes
                <span style="margin-left: 10px;">
                  <mat-slide-toggle [checked]="config.showSAC" (change)="config.showSAC = !config.showSAC; onInputChange()" [disabled]="false"></mat-slide-toggle>
                </span>
              </div>
              <div>
                <span style="margin-right: 10px;">Asset Class Detail</span>
                <span style="margin-right: 10px;"><input type="checkbox" [ngModel]="config.showSACLevel1" (change)="config.showSACLevel1 = !config.showSACLevel1; onInputChange()"/> Level 1</span>
                <span style="margin-right: 10px;"><input type="checkbox" [ngModel]="config.showSACLevel2" (change)="config.showSACLevel2 = !config.showSACLevel2; onInputChange()"/> Level 2</span>
                <span style="margin-right: 10px;"><input type="checkbox" [ngModel]="config.showSACLevel3" (change)="config.showSACLevel3 = !config.showSACLevel3; onInputChange()"/> Level 3</span>
                <span style="margin-right: 10px;"><input type="checkbox" [ngModel]="config.showSACLevel4" (change)="config.showSACLevel4 = !config.showSACLevel4; onInputChange()"/> Level 4</span>
              </div>
            </div>
          }
          <div style="padding-right: 10px; border-right: 1px solid #999; margin-right: 10px;">
            <div>{{data.envGlobalSettingsDTO?.securityCustAttrAbbr}} (User Editable)
              <span style="margin-left: 10px;">
                <mat-slide-toggle [checked]="config.showCustCat" (change)="config.showCustCat = !config.showCustCat; onInputChange()" [disabled]="false"></mat-slide-toggle>
              </span>
            </div>
          </div>
          <div style="padding-right: 10px; border-right: 1px solid #999; margin-right: 10px;">
            <div>Morningstar Stock Style
              <span style="margin-left: 10px;">
                <mat-slide-toggle [checked]="config.showMorningstarStockStyles" (change)="config.showMorningstarStockStyles = !config.showMorningstarStockStyles; onInputChange()" [disabled]="false"></mat-slide-toggle>
              </span>
            </div>
          </div>
          <div style="padding-right: 10px; margin-right: 10px;">
            <div>Security Type
              <span style="margin-left: 10px;">
                <mat-slide-toggle [checked]="config.showSACSecurityType" (change)="config.showSACSecurityType = !config.showSACSecurityType; onInputChange()" [disabled]="false"></mat-slide-toggle>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="block bold">Chart style</div>
        <div>View as
          <span style="margin-left: 10px;"><irb-dropdown-filter #chartStyleDropdown
            [(value)]="chartStyle"
            (search)="setChartStyleDropdown($event)"
            size="15" hoverPanelWidth="150"
          (valueChange)="onChartStyleChange();"></irb-dropdown-filter></span>
        </div>
      </div>
    </div>
  }
  <div class="block">
    <span style="margin-right: 10px;"><a (click)="expandAll()">Expand all</a></span>
    <span style="margin-right: 10px; padding-left: 10px; border-left: 1px solid #CCC"><a (click)="collapseAll()">Collapse all</a></span>
    <span class="right">
      @if (isPopout && !showCustomView) {
        <span style="margin-right: 10px; padding-right: 10px; border-right: 1px solid #CCC"><a (click)="toggleCustomView()">Customize View</a></span>
      }
      @if (data) {
        <span>Model used for this rebalance: <a (click)="showModelHistoryInRebalance()">{{data.historyModelName}}</a>&nbsp;<i class="pi pi-clone irb-blue clickable" style="font-size: 10px;" (click)="showModelHistoryInRebalance()"></i></span>
      }
    </span>
  </div>

  @if (data && config.showPositions) {
    <irb-com-pr-allocation-chart-group [(data)]="data" [expanded]="expanded.POSITION" (expandedChange)="expanded.POSITION = !expanded.POSITION; onInputChange()" tabTitle="Positions" groupBy="POSITION" [config]="config" (configChange)="onConfigChange($event)"></irb-com-pr-allocation-chart-group>
  }

  @if (data && config.showSAC && ENABLE_SEC_GRID_CHART) {
    <div class="pr" style="display: flex; flex-direction: row; gap: 15px">
      <div>
        @if (!expanded.SAC) {
          <i class="pi pi-chevron-down clickable" style="font-size: 14px;" (click)="expanded.SAC = !expanded.SAC; onInputChange()"></i>
        }
        @if (expanded.SAC) {
          <i class="pi pi-chevron-up clickable" style="font-size: 14px;" (click)="expanded.SAC = !expanded.SAC; onInputChange()"></i>
        }
      </div>
      <div>
        <div class="block bold" style="font-size: 18px;">Schwab Asset Classes</div>
        @if (expanded.SAC) {
          <div>
            @if (data && config.showSACLevel1) {
              <irb-com-pr-allocation-chart-group [(data)]="data" [expanded]="true" subTitle="Level 1" groupBy="SAC1" [config]="config" (configChange)="onConfigChange($event)"></irb-com-pr-allocation-chart-group>
            }
            @if (data && config.showSACLevel2) {
              <irb-com-pr-allocation-chart-group [(data)]="data" [expanded]="true" subTitle="Level 2" groupBy="SAC2" [config]="config" (configChange)="onConfigChange($event)"></irb-com-pr-allocation-chart-group>
            }
            @if (data && config.showSACLevel3) {
              <irb-com-pr-allocation-chart-group [(data)]="data" [expanded]="true"  subTitle="Level 3" groupBy="SAC3" [config]="config" (configChange)="onConfigChange($event)"></irb-com-pr-allocation-chart-group>
            }
            @if (data && config.showSACLevel4) {
              <irb-com-pr-allocation-chart-group [(data)]="data" [expanded]="true" subTitle="Level 4" groupBy="SAC4" [config]="config" (configChange)="onConfigChange($event)"></irb-com-pr-allocation-chart-group>
            }
          </div>
        }
      </div>
    </div>
  }

  @if (data && config.showCustCat) {
    <irb-com-pr-allocation-chart-group [(data)]="data" [expanded]="expanded.SEC_CATEGORY" (expandedChange)="expanded.SEC_CATEGORY = !expanded.SEC_CATEGORY; onInputChange()" tabTitle="{{data.envGlobalSettingsDTO?.securityCustAttrAbbr}}" groupBy="SEC_CATEGORY" [config]="config" (configChange)="onConfigChange($event)"></irb-com-pr-allocation-chart-group>
  }

  @if (data && config.showMorningstarStockStyles) {
    <irb-com-pr-allocation-chart-group [(data)]="data" [expanded]="expanded.STYLE_BOX" (expandedChange)="expanded.STYLE_BOX = !expanded.STYLE_BOX; onInputChange()" tabTitle="Morningstar Stock Style" groupBy="STYLE_BOX" [config]="config" (configChange)="onConfigChange($event)"></irb-com-pr-allocation-chart-group>
  }

  @if (data && config.showSACSecurityType) {
    <irb-com-pr-allocation-chart-group [(data)]="data" [expanded]="expanded.SEC_TYPE" (expandedChange)="expanded.SEC_TYPE = !expanded.SEC_TYPE; onInputChange()" tabTitle="Security Type" groupBy="SEC_TYPE" [config]="config" (configChange)="onConfigChange($event)"></irb-com-pr-allocation-chart-group>
  }
</div>
